import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  cleanStripeCheckoutParams,
  completeStripeCheckoutReturn,
  hasStripeCheckoutReturn,
} from '../utils/stripeCheckoutReturn'

const SELF_HANDLED_CHECKOUT_ROUTES = new Set([
  '/PlanCheckout',
  '/PlansPage',
  '/PricingSuccess',
])

export function useStripeCheckoutReturn() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!hasStripeCheckoutReturn(location.search)) {
      return
    }

    if (SELF_HANDLED_CHECKOUT_ROUTES.has(location.pathname)) {
      return
    }

    const params = new URLSearchParams(location.search)
    const sessionId = params.get('session_id')
    let cancelled = false

    completeStripeCheckoutReturn(sessionId || undefined).then(() => {
      if (cancelled || !hasStripeCheckoutReturn(location.search)) {
        return
      }

      navigate(
        {
          pathname: location.pathname,
          search: cleanStripeCheckoutParams(location.search),
          hash: location.hash,
        },
        { replace: true },
      )
    })

    return () => {
      cancelled = true
    }
  }, [location.pathname, location.search, location.hash, navigate])
}
